import Translatable from "@/components/translatable_text/Translatable";

interface Props {
  title: string;
}

export default function PageTitle({title}: Props) {
  return (
    <div className='w-full flex flex-col justify-center text-center md:text-start'>
      <h4 className='md:text-1xlx md:font-boldx text-purple rotate-text'>
        <Translatable>
          {title}
        </Translatable>
      </h4>
    </div>
  )
}
